import React, { Fragment, useState } from "react";
import Services from "../../api/service";
import { useParams } from "react-router-dom";
import ModalVideo from "react-modal-video";
import Header from "../../components/header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import CtaSection from "../../components/CtaSection/CtaSection";
import ProcessTechnology from "../../components/software-company-components/ProcessTechnology/ProcessTechnology";
import srImg from "../../images/services/service_details_image_1.122832cc7c289c163f98.webp";
import srImg2 from "../../images/services/service_details_image_2.21f6a045a6bcc390293d.webp";
import srImg3 from "../../images/services/service_details_image_3.06cf753fa4b90fff6b8a.webp";
import srImg4 from "../../images/services/service_details_image_4.32e165fbd1fd08e67fd6.webp";
import icon from "../../images/icons/icon_check_3.svg";

const ServiceSinglePage = (props) => {
  const { slug } = useParams();

  const ServiceDetails = Services.find((item) => item.slug === slug);

  const [isOpen, setOpen] = useState(false);

  return (
    <Fragment>
      <Header />
      <main className="page_content service-single-page">
        <PageTitle
          pageTitle={ServiceDetails.title}
          pagesub={"Details 😍"}
          pageTop={"Services"}
        />
        <section className="service_details_section section_space bg-light">
          <div className="container">
            <div className="details_item_image position-relative">
              <img src={srImg} alt="Service Details" />
              {/*<button className="video_btn ripple_effect" onClick={() => setOpen(true)}>
                                    <span className="btn_icon">
                                        <i className="fa-solid fa-play"></i>
                                    </span>
                                </button>*/}
            </div>
            <h2 className="details_item_title">{ServiceDetails.title}</h2>
            <p>
              {ServiceDetails.title} are the backbone of modern businesses,
              serving as the foundation upon which all digital operations rely.
              At our IT solution agency, we specialize in crafting robust and
              reliable network architectures tailored to meet the unique needs
              of our clients. From small businesses to large enterprises, we
              understand the critical importance of a well-designed network
              infrastructure in driving efficiency, security, and scalability.
              Our team of experienced professionals works closely with clients.
            </p>
            <p>
              We take a holistic approach to network design, considering factors
              such as bandwidth requirements, security protocols, scalability,
              and future growth potential. By leveraging industry best practices
              and cutting-edge technologies,
            </p>
            <ProcessTechnology />
            {/*<h3 className="details_item_info_title">Services Outcome</h3>
            <p className="mb-4">
              Here are six key points that can be associated with a digital
              Transformation gallery case global Digital Systems Engineer
              Services leader helping Fortune 500 companies on their innovation
              agenda:
            </p>
            <div className="row mb-4">
              <div className="col-lg-6">
                <ul className="icon_list unordered_list_block">
                  <li>
                    <span className="icon_list_icon">
                      <img src={icon} alt="Check SVG Icon" />
                    </span>
                    <span className="icon_list_text">
                      Scalability and Flexibility
                    </span>
                  </li>
                  <li>
                    <span className="icon_list_icon">
                      <img src={icon} alt="Check SVG Icon" />
                    </span>
                    <span className="icon_list_text">
                      Security and Compliance
                    </span>
                  </li>
                  <li>
                    <span className="icon_list_icon">
                      <img src={icon} alt="Check SVG Icon" />
                    </span>
                    <span className="icon_list_text">
                      Performance Optimization
                    </span>
                  </li>
                </ul>
              </div>
              <div className="col-lg-6">
                <ul className="icon_list unordered_list_block">
                  <li>
                    <span className="icon_list_icon">
                      <img src={icon} alt="Check SVG Icon" />
                    </span>
                    <span className="icon_list_text">User Experience</span>
                  </li>
                  <li>
                    <span className="icon_list_icon">
                      <img src={icon} alt="Check SVG Icon" />
                    </span>
                    <span className="icon_list_text">
                      Security and Compliance
                    </span>
                  </li>
                  <li>
                    <span className="icon_list_icon">
                      <img src={icon} alt="Check SVG Icon" />
                    </span>
                    <span className="icon_list_text">
                      Training and Education
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="details_item_image m-0">
                  <img src={srImg2} alt="Service Details" />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="details_item_image m-0">
                  <img src={srImg3} alt="Service Details" />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="details_item_image m-0">
                  <img src={srImg4} alt="Service Details" />
                </div>
              </div>
            </div>*/}
          </div>
        </section>
      </main>
      <CtaSection />
      <Footer />
      <Scrollbar />
      <ModalVideo
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId="7e90gBu4pas"
        onClose={() => setOpen(false)}
      />
    </Fragment>
  );
};
export default ServiceSinglePage;
